import { isDesktopApp } from './isDesktopApp.es.js';
import { getWebAppLink, getSupportLink, getGuestSiteLink, getPluginsLink, getSamplesLink, getSessionsLink, getNetworkLink } from './linksCreator.es.js';

const networkUrlRegex = /network-?[a-z]*\.landr\.com/;
const webAppUrlRegex = /app-?[a-z]*\.landr\.com/;
const openLink = (link, forceNewWindow = false) => {
    var _a, _b;
    const url = new URL(link);
    const currentHostname = (_a = window === null || window === void 0 ? void 0 : window.location.hostname) !== null && _a !== void 0 ? _a : '';
    const currentPort = (_b = window === null || window === void 0 ? void 0 : window.location.port) !== null && _b !== void 0 ? _b : '';
    if (forceNewWindow) {
        window.open(link, '_blank');
    }
    else if (currentHostname === url.hostname && currentPort === url.port) {
        window.history.pushState({}, '', link);
    }
    else {
        window.open(link, getWindowTarget(url));
    }
};
function getWindowTarget(url) {
    var _a;
    const currentHostname = (_a = window === null || window === void 0 ? void 0 : window.location.hostname) !== null && _a !== void 0 ? _a : '';
    // Open network app in current tab even on desktop app
    if (networkUrlRegex.test(url.hostname)) {
        return '_self';
    }
    // When navigating back from network app
    if (networkUrlRegex.test(currentHostname) && webAppUrlRegex.test(url.hostname)) {
        return '_self';
    }
    return isDesktopApp() || !url.hostname.includes('landr.com') ? '_blank' : '_self';
}
const openWebAppLink = (env, pathname = '/', forceNewWindow = false) => {
    openLink(getWebAppLink(env, pathname), forceNewWindow);
};
const openSupportLink = (language, pathname = '/', forceNewWindow = true) => {
    openLink(getSupportLink(language, pathname), forceNewWindow);
};
const openGuestSiteLink = (env, pathname = '/', forceNewWindow = false) => {
    openLink(getGuestSiteLink(env, pathname), forceNewWindow);
};
const openPluginsLink = (env, pathname = '/', forceNewWindow = false) => {
    openLink(getPluginsLink(env, pathname), forceNewWindow);
};
const openSamplesLink = (env, forceNewWindow = false) => openLink(getSamplesLink(env), forceNewWindow);
const openSessionsLink = (env, forceNewWindow = false) => openLink(getSessionsLink(env), forceNewWindow);
const openNetworkLink = (env, pathname = '', forceNewWindow = false) => openLink(getNetworkLink(env, pathname), forceNewWindow);
const openHomeLink = (env, forceNewWindow = false) => {
    const currentHostname = typeof window !== 'undefined' ? window.location.hostname : '';
    if ((currentHostname && currentHostname.match(/^app.*.landr.com$/)) ||
        (currentHostname && currentHostname === 'local.landr.com' && window.location.port === '9102')) {
        openWebAppLink(env, '/dashboard', forceNewWindow);
    }
    else {
        window.history.pushState({}, '', '/');
    }
};

export { openGuestSiteLink, openHomeLink, openLink, openNetworkLink, openPluginsLink, openSamplesLink, openSessionsLink, openSupportLink, openWebAppLink };
